module.exports = __webpack_public_path__ + "media/images/redesign-images/home/carousel/fraternity-desktop-ea03c986c460fc83ebb57f8b4147d91a.jpg";